import React, { useState, useEffect, useRef } from "react";
import axios from "../../axios";
import { get, pad } from "lodash";
import { useNavigate } from "react-router-dom";
import { connect } from "react-redux";
import * as actionTypes from "../../store/actions";
import Cookies from "js-cookie";
import { toast } from "react-toastify";
import "react-datepicker/dist/react-datepicker.css";
import "./Ticket.css";
import Overlay from "../../components/Overlay";
import { extractDate, extractOnlyDate, subadminAccessChange } from "../../utils/functions";
import { BsPlus, } from "react-icons/bs";
import Input from "../../components/Input";
import ReactReadMoreReadLess from "react-read-more-read-less";
import { RxCross2 } from "react-icons/rx";
import { CiMail } from "react-icons/ci";

import YearInput from "../../components/YearInput";
import Select from "react-select";

// Mui & material UI
import Stack from '@mui/material/Stack';
import Pagination from '@mui/material/Pagination';
import { makeStyles } from "@material-ui/core/styles";
import PaginationItem from '@mui/material/PaginationItem';
import SearchBar from "material-ui-search-bar";
import { TextField, Popover, Box } from "@mui/material";

import {
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    TablePagination,
    // Select
} from "@material-ui/core";

// icons 
import { HiMiniArrowLeft, HiMiniArrowRight } from "react-icons/hi2";

// Elements
import {
    DashboardContainer,
    DashboardWrapper,
    DashboardHeading,
    DashHeading,
    ProfileDetailForm,
    Button,
} from "./TicketManagementElement";

import Chat from "../../assets/images/chat.png"
import NoResults from "../../components/NoResult";


const useStyles = makeStyles((theme) => ({
    table: {
        borderCollapse: 'separate',
        borderSpacing: '0 6px', // adds vertical spacing between rows
    },
    tableMainContainer: {
        maxHeight: "65vh",
        overflowX: "auto",
        overflowY: "auto",
        borderTopLeftRadius: "4px",
        borderTopRightRadius: "4px",
    },
    tableHeadingRow: {
        position: "sticky", // Make header sticky
        top: 0, // Stick to the top
        zIndex: 1, // Ensure it appears above other rows
        background: "#FFFFFF", // Header background color
        // border: "1px solid rgba(17, 153, 38, 0.20)",

    },
    tableBodyRow: {
        background: "#FFFFFF",
        // border: "1px solid rgba(17, 153, 38, 0.20)",

        "&:hover": {
            backgroundColor: "#f5f5f5",
        },
    },
    tableHeadingCell: {
        // padding: "0.5rem 1rem !important",
        textAlign: "center",
        fontSize: "14px",
        color: "#1C2D28",
        fontWeight: "500",
        // border: "1px solid #D9E3D9",
        whiteSpace: "nowrap",
        background: "#FFFFFF",
        border: "none"
    },
    textMiddle: {
        // padding: "0.4rem 1rem !important",
        verticalAlign: "middle !important",
        textAlign: "center",
        fontSize: "14px",
        color: "#484848",
        fontFamily: "Roboto",
        fontWeight: "400",
        background: "#FFFFFF",
        border: "none"
    },
    tablePaginationStyle: {
        borderTop: "1px solid #0000001a",
        borderRadius: "0rem 0rem 0.4rem 0.4rem",
        overflowY: "hidden",
    },
    paginationContainer: {
        marginTop: "2rem",
        display: "flex",
        alignItems: "center",
        justifyContent: "center"
    }
}));


const TicketManagement = ({ setUsers, userData }) => {
    const adminData = JSON.parse(localStorage.getItem("userData") || userData || sessionStorage.getItem("userData"));

    const ticketManagementPermissions = adminData?.adminpermissions?.modules?.find(
        (module) => module.moduleName === "Ticket Management"
    )?.permissions || {};

    const canView = !!ticketManagementPermissions.view;
    const canAdd = !!ticketManagementPermissions.add;
    const canEdit = !!ticketManagementPermissions.edit;
    const canDelete = !!ticketManagementPermissions.delete;
    const canBlockUnblock = !!ticketManagementPermissions.blockUnblock;
    const isSubadmin = adminData?.userType?.toLowerCase() === "subadmin";

    const classes = useStyles();
    const navigate = useNavigate();
    const [isLoading, setIsLoading] = useState(false);
    const [tableData, setTableData] = useState([]);
    const [anchorEl, setAnchorEl] = useState(null);
    const [anchorElData, setAnchorElData] = useState(null);
    const [title, setTitle] = useState("");
    const [userType, setUserType] = useState("");
    const [filterKey, setFilterKey] = useState(0);
    const [assignedAdmin, setAssignedAdmin] = useState([])
    const [resetFilters, setResetFilters] = useState(false);

    const [date, setDate] = useState(null);
    const [filterDates, setFilterDates] = useState({
        date: "",
    });

    const [selectedTypeOption, setSelectedTypeOption] = useState(null); // For service type filteri
    const [selectedGigStatusOption, setSelectedGigStatusOption] = useState(null); // For Booking status filtering



    // For Pagination
    const [page, setPage] = useState(1);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [totalDocs, setTotalDocs] = useState(0);

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(+event.target.value);
        setPage(1); // Reset to the first page when rows per page change
    };

    const handleChangePage = (event, newPage) => {
        setPage(newPage); // Update page and trigger data fetch
    };


    // For Search functionality
    const [searchTerm, setSearchTerm] = useState("");

    function myDeb(call, d = 1000) {
        let timer;
        return function (...args) {
            clearTimeout(timer);
            timer = setTimeout(() => {
                call(...args);
            }, d);
        };
    }

    const SearchAccountManagement = myDeb((search) => {
        // setSelectedRows([]);
        setSearchTerm(search);
        setPage(1); // Reset to the first page on search
    });

    const cancelSearch = () => {
        setSearchTerm("");
        setPage(1); // Reset to the first page when search is canceled
    };



    const GigStatusOptions = [
        { value: 0, label: "Open", color: "green" },
        { value: 1, label: "In Progress", color: "orange" }, // yellow is hard to read, so use orange
        { value: 2, label: "Closed", color: "red" },
    ];

    const customStyles = {
        control: (base) => ({
            ...base,
            minHeight: 30,
            width: 120,
            fontSize: 12,
            cursor: "pointer",
        }),
        dropdownIndicator: (base) => ({
            ...base,
            padding: 4,
            cursor: "pointer",
        }),
        clearIndicator: (base) => ({
            ...base,
            padding: 4,
            cursor: "pointer",
        }),
        valueContainer: (base) => ({
            ...base,
            padding: "0 6px",
            cursor: "pointer",
        }),
        option: (base, { data, isFocused, isSelected }) => ({
            ...base,
            color: data.color,
            backgroundColor: isSelected ? "#f0f0f0" : isFocused ? "#e6e6e6" : "white",
            fontWeight: isSelected ? "bold" : "normal",
            cursor: "pointer",
        }),
        singleValue: (base, { data }) => ({
            ...base,
            color: data.color,
            fontWeight: "bold",
        }),
    };


    const userTypeOptions = assignedAdmin.map((item) => ({
        label: item.name,
        value: item.userId,
    }));


    const handleFilterClick = (event) => {
        setAnchorEl(event.currentTarget); // Open the filter popover
    };

    const handleApply = () => {
        if (!date && !selectedTypeOption && !selectedGigStatusOption) {
            toast.warning("Please select at least one field.", {
                position: "top-right",
            });
            return;
        }

        const adjustDateTime = (date, isEndOfDay = false) => {
            if (!date) return "";

            const adjustedDate = new Date(date);
            if (isEndOfDay) {
                adjustedDate.setHours(23, 59, 59, 999);
            } else {
                adjustedDate.setHours(0, 0, 0, 0);
            }

            return `${adjustedDate.getFullYear()}-${String(adjustedDate.getMonth() + 1).padStart(2, "0")}-${String(adjustedDate.getDate()).padStart(2, "0")}T${String(adjustedDate.getHours()).padStart(2, "0")}:${String(adjustedDate.getMinutes()).padStart(2, "0")}:${String(adjustedDate.getSeconds()).padStart(2, "0")}.000Z`;
        };

        const normalizedStartDate = adjustDateTime(date, false);

        setFilterDates({ date: normalizedStartDate });
        setAnchorEl(null);
        setPage(1);

        // 👉 Call API manually here with filters
        getTicketList(1, normalizedStartDate, selectedGigStatusOption, selectedTypeOption);
    };

    const handleCancel = () => {
        setDate(null);
        setSelectedTypeOption(null);
        setSelectedGigStatusOption(null);
        setFilterDates({ date: "" });
        setPage(1);
        setResetFilters(true); // Trigger reset
    };

    const handleClose = () => {
        setAnchorEl(null); // Only close the popover without resetting
    };

    const handleStartDateChange = (date) => {
        setDate(date || null); // Update the start date if valid
    };

    const open = Boolean(anchorEl);
    const id = open ? "filter-popover" : undefined;


    const [isSidebarOpen, setIsSidebarOpen] = useState(false);
    const sidebarRef = useRef(null);

    const handleChatClick = () => {
        setIsSidebarOpen(true);
    };
    const handleCloseChat = () => {
        setIsSidebarOpen(false);
    };

    const handleClickOutside = (event) => {
        if (
            sidebarRef.current &&
            !sidebarRef.current.contains(event.target)
        ) {
            setIsSidebarOpen(false);
        }
    };

    useEffect(() => {
        if (isSidebarOpen) {
            document.addEventListener("mousedown", handleClickOutside);
        } else {
            document.removeEventListener("mousedown", handleClickOutside);
        }

        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [isSidebarOpen]);




    // Get user data
    useEffect(() => {
        getTicketList(page);
        getAssignedAdmin()
        if (resetFilters) {
            getTicketList(1, "", [], []);
            setResetFilters(false); // Reset the flag
        }

    }, [page, rowsPerPage, searchTerm, resetFilters]);

    const getTicketList = async (currentPage) => {
        setIsLoading(true);
        setTotalDocs(0);

        try {
            const { data } = await axios.post(`/private/getTicketList?page=${currentPage}&limit=${rowsPerPage}&search=${searchTerm}`, {
                date: date || undefined,
                status: selectedGigStatusOption?.length ? selectedGigStatusOption.map((opt) => opt.value) : [],
                agent: selectedTypeOption?.length ? selectedTypeOption.map((opt) => opt.value) : [],
            });

            setTableData(data?.data?.docs);
            setTotalDocs(data?.data?.totalDocs);
        } catch (error) {
            if (error?.response?.status === 419) {
                localStorage.clear();
                Cookies.remove("showProfileSidebar");
                setUsers("");

                toast.error(`${error.response.data?.message}`, {
                    position: "top-right",
                });

                navigate("/");
            } else if (error?.response?.status === 901) {
                subadminAccessChange(navigate);
                toast.error(`${error.response.data?.message}`, {
                    position: "top-right",
                });
            } else {
                console.log("error", error?.response)
            }
        } finally {
            setIsLoading(false);
        }
    };


    const getAssignedAdmin = async (currentPage) => {
        setIsLoading(true);
        setTotalDocs(0);

        try {
            const { data } = await axios.get(`/private/getAgentList`);

            setAssignedAdmin(data?.data);

        } catch (error) {
            if (error?.response?.status === 419) {
                localStorage.clear();
                Cookies.remove("showProfileSidebar");
                setUsers("");

                toast.error(`${error.response.data?.message}`, {
                    position: "top-right",
                });

                navigate("/");
            } else if (error?.response?.status === 901) {
                subadminAccessChange(navigate);
                toast.error(`${error.response.data?.message}`, {
                    position: "top-right",
                });
            } else {
                console.log("error", error?.response)
            }
        } finally {
            setIsLoading(false);
        }
    };



    const handleUpdate = async (values) => {
        setIsLoading(true);
        try {
            const { data } = await axios.put(
                `private/updateUserTicketStatus`,
                values
            );
            toast.success(data?.message);
            //  setIsLoading(true);
            getTicketList(page);

        } catch (error) {
            handleErrorResponse(error);
        } finally {
            setIsLoading(false);
        }
    };

    const updateUserTicketStatus = async (values) => {
        setIsLoading(true);
        try {
            const { data } = await axios.put(
                `private/updateUserTicketStatus`,
                values
            );
            toast.success(data?.message);
            //  setIsLoading(true);
            getTicketList(page);

        } catch (error) {
            handleErrorResponse(error);
        } finally {
            setIsLoading(false);
        }
    };

    const handleErrorResponse = (error) => {
        const status = error?.response?.data?.status;
        const message =
            error?.response?.data?.errors?.[0]?.msg ||
            error?.response?.data?.message ||
            "Something went wrong";

        toast.error(message, { position: "top-right" });

        if (status === 422) {
            toast.error(message);
        } else if (status === 901) {
            subadminAccessChange(navigate);
        } else if (status === 419) {
            localStorage.clear();
            Cookies.remove("showProfileSidebar");
            setUsers("");
            navigate("/");
        }
    };



    return (
        <>
            <DashboardContainer>
                <DashboardWrapper>
                    <ProfileDetailForm>
                        <DashboardHeading>
                            <div
                                style={{
                                    marginBottom: "0.5rem"
                                }}
                            >
                                <div className="common-heading">Ticket Management</div>
                            </div>
                        </DashboardHeading>



                        <div style={{ display: "flex", alignItems: "center", gap: "1rem", marginBottom: "1rem" }}>
                            <SearchBar
                                style={{
                                    minWidth: "25rem",
                                    height: "40px",
                                    borderRadius: "20px",
                                    backgroundColor: "#F8F9FB",
                                    color: "#212121",
                                    fontStyle: "Italic",
                                    fontWeight: 300,
                                    fontSize: "15px",
                                    fontFamily: "Roboto",
                                }}
                                className={"heightfix"}
                                onChange={(e) => {
                                    SearchAccountManagement(e);
                                }}
                                onCancelSearch={cancelSearch}
                                placeholder="Search by Ticket ID, UserName..."
                                inputProps={{ maxLength: 30 }}
                            />
                            <div
                                type="button"
                                style={{ color: "#5088FB", fontSize: "16px", fontFamily: "Roboto", fontWeight: "500" }}
                                onClick={handleFilterClick}
                            >
                                <BsPlus
                                    style={{
                                        color: "#5088FB",
                                        marginRight: "6px",
                                        fontSize: "1.5rem",
                                    }}
                                />
                                Advance Filter
                            </div>
                        </div>


                        <TableContainer
                            className={classes.tableMainContainer}
                        >
                            <Table className={classes.table}>
                                <TableHead>
                                    <TableRow className={classes.tableHeadingRow}>
                                        <TableCell className={classes.tableHeadingCell}>
                                            S.No
                                        </TableCell>
                                        <TableCell className={classes.tableHeadingCell}>
                                            Date
                                        </TableCell>
                                        <TableCell className={classes.tableHeadingCell}>
                                            Status
                                        </TableCell>
                                        <TableCell className={classes.tableHeadingCell}>
                                            Ticket ID
                                        </TableCell>
                                        <TableCell className={classes.tableHeadingCell}>
                                            <div style={{ textAlign: "left", marginLeft: "3rem" }}>
                                                User Name
                                            </div>
                                        </TableCell>
                                        <TableCell className={classes.tableHeadingCell}>
                                            <div style={{ textAlign: "left", marginLeft: "3rem" }}>
                                                Category
                                            </div>
                                        </TableCell>
                                        {!(isSubadmin && canView) && (
                                            <TableCell className={classes.tableHeadingCell}>
                                                Assigned Admin
                                            </TableCell>
                                        )}
                                        <TableCell className={classes.tableHeadingCell}>
                                            Last Activity
                                        </TableCell>
                                    </TableRow>
                                </TableHead>
                                {tableData && tableData.length > 0 ? (
                                    <>
                                        <TableBody>
                                            {tableData.map((user, index) => (
                                                <TableRow className={classes.tableBodyRow} key={user._id}>
                                                    <TableCell className={classes.textMiddle}>
                                                        <div>{index + 1 + rowsPerPage * (page - 1)}</div>
                                                    </TableCell>
                                                    <TableCell className={classes.textMiddle}>
                                                        <div>
                                                            {extractDate(get(user, "createdAt", "---"))}
                                                        </div>
                                                    </TableCell>
                                                    <TableCell className={classes.textMiddle} >
                                                        <div style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>

                                                            <Select
                                                                value={
                                                                    GigStatusOptions.find((opt) => opt.value === get(user, "status")) || null
                                                                }
                                                                onChange={(option) => {
                                                                    const payload = {
                                                                        status: option?.value,
                                                                        ticketId: user?.ticketId,
                                                                    };
                                                                    handleUpdate(payload);
                                                                }}
                                                                options={GigStatusOptions}
                                                                placeholder="Select status"
                                                                isSearchable={false}
                                                                styles={customStyles}
                                                            />

                                                        </div>
                                                    </TableCell>
                                                    <TableCell className={classes.textMiddle}>
                                                        <div
                                                            style={{
                                                                display: "flex",
                                                                gap: "0.5rem",
                                                                alignItems: "center",
                                                                justifyContent: "center",
                                                            }}
                                                        >
                                                            {/* Badge attached to ticketId */}
                                                            <div style={{ position: "relative", display: "inline-block" }}>
                                                                <div
                                                                    style={{
                                                                        fontFamily: "Roboto",
                                                                        fontWeight: "500",
                                                                        fontSize: "14px",
                                                                        color: "#5088FB",
                                                                        textDecoration: "underline",
                                                                        cursor: "pointer",
                                                                    }}
                                                                    onClick={() =>
                                                                        navigate(`/ticketManagementHistory/${user._id}`, {
                                                                            state: { from: "ticketManagement", tabStatus: page, rowsPerPage },
                                                                        })
                                                                    }
                                                                >
                                                                    {String(get(user, "ticketId", "")).padStart(4, "0") || "---"}
                                                                </div>

                                                                {/* Superscript badge */}
                                                                {get(user, "count") > 0 && (
                                                                    <div
                                                                        style={{
                                                                            position: "absolute",
                                                                            top: "-6px",
                                                                            right: "-15px",
                                                                            background: "#fa7878ff",
                                                                            height: "0.9rem",
                                                                            width: "0.9rem",
                                                                            borderRadius: "50%",
                                                                            color: "#fff",
                                                                            fontSize: "10px",
                                                                            display: "flex",
                                                                            alignItems: "center",
                                                                            justifyContent: "center",
                                                                        }}
                                                                    >
                                                                        {get(user, "count", "---")}
                                                                    </div>
                                                                )}
                                                            </div>
                                                        </div>
                                                    </TableCell>
                                                    <TableCell className={classes.textMiddle}>
                                                        <div style={{
                                                            color: "#29A4C0",
                                                            fontFamily: "Roboto",
                                                            fontWeight: "500",
                                                            fontSize: "14px",
                                                            textDecoration: "underline",
                                                            cursor: "pointer",
                                                            textAlign: "left",
                                                            marginLeft: "3rem"

                                                        }}
                                                            onClick={() => navigate(`/userDetails/${user.userId}`,
                                                                { state: { from: "ticketManagement", tabStatus: page, rowsPerPage } }

                                                            )}
                                                        >{(get(user, "userName", "---"))}</div>
                                                    </TableCell>
                                                    <TableCell className={classes.textMiddle}>
                                                        <div style={{ textAlign: "left", marginLeft: "3rem" }}>{(get(user, "category", "---"))}</div>
                                                    </TableCell>


                                                    {!(isSubadmin && canView) && (

                                                        <TableCell className={classes.textMiddle}>

                                                            <div style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
                                                                <Select
                                                                    value={
                                                                        userTypeOptions.find((opt) => opt.value === assignedAdmin?.userId) || null
                                                                    }
                                                                    onChange={(option) => {
                                                                        const payload = {
                                                                            assignedAgentId: option?.value, // send selected userId
                                                                            ticketId: user?.ticketId,
                                                                        };
                                                                        updateUserTicketStatus(payload);
                                                                    }}
                                                                    options={userTypeOptions} // should have { label: name, value: userId }
                                                                    placeholder={user?.assignedAgentName || "Select status"}
                                                                    isSearchable={false}
                                                                    isDisabled={user?.status === 2} //  Disable if value is "2"
                                                                    styles={customStyles}
                                                                />
                                                            </div>

                                                        </TableCell>
                                                    )}
                                                    <TableCell className={classes.textMiddle}>
                                                        <div>{user?.lastMessageDate ? extractDate(user.lastMessageDate) : "N/A"}</div>
                                                    </TableCell>
                                                </TableRow>
                                            ))}
                                        </TableBody>
                                    </>
                                ) : (
                                    <>
                                        <TableBody>
                                            <TableRow>
                                                <TableCell colSpan={13} align="center" style={{ padding: "2rem", border: "none" }}>
                                                    <DashHeading style={{ textAlign: "center", padding: "2rem" }}><NoResults /></DashHeading>
                                                </TableCell>
                                            </TableRow>
                                        </TableBody>
                                    </>
                                )}
                            </Table>
                        </TableContainer>
                        {(tableData && tableData.length > 0) && (
                            <>
                                <Stack spacing={2} className={classes.paginationContainer}>
                                    <Pagination
                                        count={Math.ceil(totalDocs / rowsPerPage)} // Total number of pages based on the count and rowsPerPage
                                        page={page}
                                        onChange={(event, value) => handleChangePage(event, value)} // Update page
                                        renderItem={(item) => (
                                            <PaginationItem
                                                slots={{ previous: HiMiniArrowLeft, next: HiMiniArrowRight }}
                                                {...item}
                                            />
                                        )}
                                    />
                                </Stack>
                            </>
                        )}


                        {/* <div
                            style={{
                                position: "fixed",
                                bottom: "2rem",
                                right: "2rem",
                                zIndex: 999,
                            }}
                        >
                            <img
                                src={Chat}
                                alt="Chat Icon"
                                style={{ cursor: "pointer" }}
                                onClick={handleChatClick}
                            />
                        </div> */}

                        {/* Sidebar */}
                        <div
                            ref={sidebarRef}
                            style={{
                                position: "fixed",
                                top: "6rem",
                                right: isSidebarOpen ? 0 : "-35rem",
                                height: "90vh",
                                width: "35rem",
                                backgroundColor: "#F3F7FF",
                                boxShadow: "-2px 0 5px rgba(0,0,0,0.3)",
                                transition: "right 0.3s ease-in-out",
                                zIndex: 1000,
                                padding: "1rem",
                            }}
                        >
                            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", borderBottom: "1px solid #00000033" }}>
                                <div className="textMailContent"> <CiMail style={{ fontSize: "1.4rem" }} /> Assisting David Walker</div>
                                <div
                                    // onClick={handleCloseChat}
                                    onClick={() => setIsSidebarOpen(false)}
                                    style={{
                                        fontSize: "1.4rem",
                                        cursor: "pointer",
                                    }}
                                >
                                    <RxCross2 />
                                </div>
                            </div>
                            <div className="chatDataContent">

                            </div>



                        </div>

                    </ProfileDetailForm>
                </DashboardWrapper>
            </DashboardContainer >



            <Popover
                id={id}
                open={open}
                anchorEl={anchorEl}
                onClose={handleClose}
                anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "left",
                }}
                transformOrigin={{
                    vertical: "top",
                    horizontal: "left",
                }}
            >
                <Box sx={{ p: 2, width: "300px" }}>
                    <div
                        style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                            marginBottom: "0.8rem",
                        }}
                    >
                        <div className="text-filter">Advance Filter</div>
                        <div className="clear-filter" onClick={handleCancel}>
                            Reset All
                        </div>
                    </div>



                    <div className="mb-3">
                        <label className="lable_name_data_text">Date</label>
                        <YearInput
                            selected={date}
                            onChange={handleStartDateChange}
                            placeholderText="Select Date"
                            maxDate={new Date()}
                            className="selectInput"
                        // popperClassName="small-datepicker"
                        />
                    </div>


                    <div className="mb-3">
                        <label className="lable_name_data_text">Ticket Status</label>
                        <Select
                            isMulti
                            value={selectedGigStatusOption}
                            onChange={setSelectedGigStatusOption}
                            options={GigStatusOptions}
                            placeholder="Select Ticket Status"
                            className="selectInput"

                        />
                    </div>

                    {!(isSubadmin && canView) && (

                        <div className="mb-3">
                            <label className="lable_name_data_text">Assigned Admin</label>
                            <Select
                                isMulti
                                value={selectedTypeOption}
                                onChange={setSelectedTypeOption}
                                options={userTypeOptions}
                                placeholder="Select Status"
                                className="selectInput"

                            />
                        </div>
                    )}
                    <Box
                        sx={{ display: "flex", justifyContent: "center", mt: 3, gap: 2 }}
                    >
                        <Button onClick={handleClose} color="secondary">
                            Cancel
                        </Button>
                        <Button
                            onClick={handleApply}
                            style={{
                                background: "#5088FB",
                                color: "#ffffff",
                                padding: "0px 15px"
                            }}
                        >
                            Apply
                        </Button>
                    </Box>
                </Box>
            </Popover>




            {isLoading && <Overlay />}
        </>
    );
};

const mapStateToProps = (state) => {
    return {
        userData: state.userData,
        locationData: state.locations,
        defaultState: state.defaultState,
        sidebar: state.sidebar,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        setUsers: (updatedValue) => {
            dispatch({
                type: actionTypes.UPDATE_USER,
                updatedUser: updatedValue,
            });
        },
        setDefaultState: (updatedValue) => {
            dispatch({
                type: actionTypes.UPDATE_DEFAULT,
                updateDefault: updatedValue,
            });
        },
        setSidebar: (updatedValue) => {
            dispatch({
                type: actionTypes.UPDATE_SIDEBAR,
                updateSidebar: updatedValue,
            });
        },
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(TicketManagement);









